import { __extends } from "tslib";
import { makeEventParametersResolver } from '../resolvers/eventParameters';
import { StatistBrowserClient } from './statist-browser-client';
import { clientInitOptionsResolver } from '../resolvers/clientInitOptions';
var StatistMetricClient = /** @class */ (function (_super) {
    __extends(StatistMetricClient, _super);
    function StatistMetricClient(options) {
        var resolvedOptions = clientInitOptionsResolver(options);
        return _super.call(this, resolvedOptions.clientParameters, StatistBrowserClient.createTransport(options), resolvedOptions.eventParameters || makeEventParametersResolver(), resolvedOptions.sessionTimeout, resolvedOptions.getClientParametersOverride) || this;
    }
    StatistMetricClient.prototype.send = function (project, event, parameters, clientParameters) {
        return _super.prototype.send.call(this, project, event, parameters, clientParameters);
    };
    return StatistMetricClient;
}(StatistBrowserClient));
export { StatistMetricClient };
//# sourceMappingURL=statist-metric-client.js.map